<div class="dialog-container">

  <form [formGroup]="myform" (ngSubmit)="Onsubmit()">
    <div class="dialog-header">
      <div class="header-content">
        <div class="icon-container">
          <!-- <i class="fa fa-lock" aria-hidden="true"></i> -->
           <img src="assets/images/lockico.svg" style="width: 25px;"/>
        </div>
        <div class="header-text">
          <h2 style="font-weight: 600">Change Password</h2>
          <p style="font-size: 13px;">Make sure your new password is at least 8 characters long</p>
        </div>
      </div>
      <img class="close-button" src="assets/images/close-circle.svg" (click)="cancel()" />
    </div>

    <!-- Current Password -->
    <div class="form-group">
      <label>Current Password</label>
      <div class="input-wrapper">
        <input [type]="showCurrent ? 'text' : 'password'" formControlName="old" 
         (keydown)="validateSpace($event)"/>
        <span class="toggle-icon" (click)="toggleVisibility('current')">
          <i [ngClass]="showCurrent ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
        </span>
      </div>
      <!-- <div class="error" *ngIf="myform.get('old')?.touched && myform.get('old')?.hasError('required')">
        Current password is required.
      </div> -->
      <div class="error" *ngIf="(submitted || myform.get('old')?.dirty) && myform.get('old')?.hasError('required')">
        Current Password is required.
      </div>

      <!-- <div class="error" *ngIf="myform.get('old')?.touched && myform.get('old')?.hasError('pattern')">
        Password cannot contain spaces.
      </div> -->
    </div>

    <!-- New Password -->
    <div class="form-group">
      <label>New Password</label>
      <div class="input-wrapper">
        <input [type]="showNew ? 'text' : 'password'"  formControlName="new" 
        (keydown)="validateSpace($event)" (input)="checkPassword($event);onInputTrim('new')"/>
        <span class="toggle-icon" (click)="toggleVisibility('new')">
          <i [ngClass]="showNew ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
        </span>
      </div>
      <!-- <div class="error" *ngIf="myform.get('new')?.touched && myform.get('new')?.hasError('required')">
        New password is required.
      </div> -->
      <!-- <div class="error" *ngIf="myform.get('new')?.touched && myform.get('new')?.hasError('minlength')">
        Password must be at least 8 characters.
      </div> -->
      <!-- <div class="error" *ngIf="myform.get('new')?.touched && myform.get('new')?.hasError('pattern')">
        Password cannot contain spaces.
      </div> -->
      <div class="error" *ngIf="myform.errors?.sameAsOld && myform.get('new')?.touched && !passwordError">
        New Password cannot be the same as Current Password.
      </div>
      <div class="error" *ngIf="passwordError">{{ passwordError }}</div>
    </div>

    <!-- Confirm Password -->
    <div class="form-group">
      <label>Confirm Password</label>
      <div class="input-wrapper">
        <input [type]="showConfirm ? 'text' : 'password'"  formControlName="con" 
        (keydown)="validateSpace($event)" (input)="onInputTrim('con')"/>
        <span class="toggle-icon" (click)="toggleVisibility('confirm')">
          <i [ngClass]="showConfirm ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
        </span>
      </div>
      <!-- <div class="error" *ngIf="myform.get('con')?.touched && myform.get('con')?.hasError('required')">
        Confirm password is required.
      </div> -->
      <div class="error" *ngIf="myform.errors?.notSame && myform.get('con')?.touched">
        Passwords do not match.
      </div>
      <!-- <div class="error" *ngIf="myform.get('con')?.touched && myform.get('con')?.hasError('pattern')">
        Password cannot contain spaces.
      </div> -->

    </div>

    <div class="action-buttons">
      <button class="cancel-btn" type="button" (click)="cancel()">Cancel</button>
      <button class="save-btn" type="submit" [disabled]="myform.invalid">Save</button>
    </div>
  </form>

</div>